import React, { useState, useEffect } from "react";
import axios from "axios";
import GradientButton from '../../../components/GradientButton/GradientButton';
import CancelButton from '../../../components/CancelButton/CancelButton';
import { checkPlateStatus, cleanBackendErrorMessage } from '../../../utils/plateValidation';
// import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';

const patterns = {
    carro: "[A-Z]{3}[0-9]{3}",
    moto: "[A-Z]{3}[0-9]{2}[A-Z]?",
    otro: ".{1,7}",
};

const buildInitialFormData = (data = {}) => ({
    id: data._id || "",
    type_vehicle: data.type_vehicle || "",
    placa: data.placa || "",
    telephone: data.telephone || "",
    requireInvoice: data.requireInvoice ?? data.requiredInvoice ?? false,
    requiredInvoice: data.requiredInvoice ?? data.requireInvoice ?? false,
    ownerName: data.ownerName || "",
    idNumber: data.idNumber || "",
    email: data.email || "",
    address: data.address || "",
    hasHelmets: data.hasHelmets ?? false,
    numberOfHelmets: data.numberOfHelmets ?? 0,
    booking: data.booking ?? false,
    numberOfBooking: data.numberOfBooking ?? "",
    ...data,
});

const ParkingRegisterForm = ({ parkingData = {}, onSuccess, onCancel, onError }) => {
    const [formData, setFormData] = useState(() => buildInitialFormData(parkingData));

        // const [modal, setModal] = useState({ open: false, type: "error", title: "", message: "" });
    

useEffect(() => {
  if (parkingData && Object.keys(parkingData).length > 0) {
    setFormData(prev => {
      const nextData = buildInitialFormData(parkingData);
      const isSame = Object.keys(nextData).every(
        key => prev[key] === nextData[key]
      );
      return isSame ? prev : nextData;
    });
  }
}, [parkingData]);

    // const closeModal = () => setModal((prev) => ({ ...prev, open: false }));

    const handleTypeChange = (e) => {
        const newType = e.target.value;
        setFormData((prev) => ({
            ...prev,
            type_vehicle: newType,
            placa: "",
        }));
    };

    const handlePlacaChange = (e) => {
        const rawValue = e.target.value.toUpperCase();
        setFormData((prev) => {
            const type = prev.type_vehicle;
            let validValue = "";

            if (type === "carro") {
                for (let i = 0; i < rawValue.length && i < 6; i++) {
                    const char = rawValue[i];
                    if (i < 3 && /[A-Z]/.test(char)) validValue += char;
                    if (i >= 3 && /[0-9]/.test(char)) validValue += char;
                }
            } else if (type === "moto") {
                for (let i = 0; i < rawValue.length && i < 6; i++) {
                    const char = rawValue[i];
                    if (i < 3 && /[A-Z]/.test(char)) validValue += char;
                    else if (i >= 3 && i < 5 && /[0-9]/.test(char)) validValue += char;
                    else if (i === 5 && /[A-Z]/.test(char)) validValue += char;
                }
            } else {
                validValue = rawValue.replace(/[^A-Z0-9]/g, "").slice(0, 7);
            }

            return {
                ...prev,
                placa: validValue,
            };
        });
    };

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        setFormData((prev) => {
            const updated = {
                ...prev,
                [name]: type === "checkbox" ? checked : value,
            };

            if (name === "requiredInvoice") {
                updated.requireInvoice = checked;
            }

            return updated;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const normalizedPlate = formData.placa?.trim().toUpperCase();

            if (!normalizedPlate) {
                throw new Error("Debe ingresar una placa válida.");
            }

            const plateExists = await checkPlateStatus(normalizedPlate);
            if (plateExists && (!parkingData || !parkingData._id || parkingData.placa?.toUpperCase() !== normalizedPlate)) {
                throw new Error(`La placa ${normalizedPlate} ya se encuentra registrada.`);
            }

            const token = localStorage.getItem("access_token");
            const payload = {
                type_vehicle: formData.type_vehicle,
                placa: normalizedPlate,
                telephone: formData.telephone || "",
                booking: Boolean(formData.booking),
                hasHelmets: Boolean(formData.hasHelmets),
                numberOfBooking: formData.numberOfBooking || "",
                numberOfHelmets: Number(formData.numberOfHelmets) || 0,
                requiredInvoice: Boolean(formData.requiredInvoice),
            };

            if (parkingData && parkingData._id) {
                await axios.put(
                    `${process.env.REACT_APP_API_URL}/parkingregister/update/${parkingData._id}`,
                    payload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
            } else {
                await axios.post(
                    `${process.env.REACT_APP_API_URL}/parkingregister/create`,
                    payload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
            }

            if (onSuccess) onSuccess();
        } catch (err) {
            const backendMessage =
            err?.response?.data?.error ||
            err?.response?.data?.errors?.[0] ||
            err?.response?.data?.message ||
            err?.message ||
            "Ocurrió un error inesperado. Intenta nuevamente.";

            console.error("Error en formulario de registro de parqueo:", backendMessage);
            onError?.(cleanBackendErrorMessage(backendMessage));

            // setModal({
            //     open: true,
            //     type: "error",
            //     title: "Error al guardar",
            //     message: backendMessage,
            // });
        }
    };

    return (
        <>
                <form
            onSubmit={handleSubmit}
            className="bg-white px-6 py-6 rounded-lg shadow-md flex flex-col gap-4 text-gray-700 font-sans w-full"
        >
            {/* Grid de 2 columnas */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="flex flex-col">
                    <label htmlFor="vehicleType" className="text-gray-600 mb-1">
                        Tipo de Vehículo
                    </label>
                    <select
                        id="vehicleType"
                        name="type_vehicle"
                        value={formData.type_vehicle}
                        onChange={handleTypeChange}
                        className={`border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600 ${formData.type_vehicle === "" ? "text-gray-400" : "text-gray-900"}`}
                    >
                    <option value="" disabled hidden>
                        Selecciona el tipo de vehículo...
                    </option>                        
                    <option value="carro">Carro</option>
                    <option value="moto">Moto</option>
                    <option value="otro">Otro</option>
                    </select>
                </div>

                <div className="flex flex-col">
                    <label htmlFor="placa" className="text-gray-600 mb-1">
                        Placa del Vehículo
                    </label>
                    <input
                        type="text"
                        name="placa"
                        id="placa"
                        value={formData.placa}
                        onChange={handlePlacaChange}
                        disabled={!formData.type_vehicle}
                        pattern={patterns[formData.type_vehicle]}
                        title={
                            formData.type_vehicle === "carro"
                                ? "Formato: 3 letras y 3 números (AAA123)"
                                : formData.type_vehicle === "moto"
                                    ? "Formato: 3 letras, 2 números y opcional 1 letra (AAA12 o AAA12B)"
                                    : "Máximo 7 caracteres"
                        }
                        className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600 uppercase placeholder:normal-case"
                        placeholder={
                            !formData.type_vehicle
                                ? "Seleccione tipo primero"
                                : formData.type_vehicle === "carro"
                                    ? "ABC123"
                                    : formData.type_vehicle === "moto"
                                        ? "ABC12D"
                                        : "Cualquier ID"
                        }
                        required
                    />
                </div>

                <div className="flex flex-col">
                    <label htmlFor="telephone" className="text-gray-600 mb-1">
                        Teléfono
                    </label>
                    <input
                        type="text"
                        name="telephone"
                        id="telephone"
                        value={formData.telephone}
                        onChange={handleChange}
                        className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                    />
                </div>

                {/* Columna con checkboxes en horizontal */}
                <div className="flex flex-col">
                    <label className="text-gray-600 mb-1">Opciones</label>
                    <div className="flex gap-6">
                        {/* Checkbox cascos */}
                        <div className="flex items-center gap-2">
                            <input
                                type="checkbox"
                                id="hasHelmets"
                                name="hasHelmets"
                                checked={formData.hasHelmets}
                                onChange={handleChange}
                                className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-600"
                            />
                            <span className="text-sm text-gray-700">Cascos?</span>
                        </div>

                        {/* Checkbox factura */}
                        <div className="flex items-center gap-2">
                            <input
                                type="checkbox"
                                id="booking"
                                name="booking"
                                checked={formData.booking}
                                onChange={handleChange}
                                className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-600"
                            />
                            <span className="text-sm text-gray-700">Reserva?</span>
                        </div>

                        {/* Checkbox factura */}
                        <div className="flex items-center gap-2">
                            <input
                                type="checkbox"
                                id="requireInvoice"
                                name="requiredInvoice"
                                checked={formData.requiredInvoice}
                                onChange={handleChange}
                                className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-600"
                            />
                            <span className="text-sm text-gray-700">Factura?</span>
                        </div>
                    </div>
                </div>

                {formData.hasHelmets && (
                    <>
                        <div className="flex flex-col">
                            <label htmlFor="ownerName" className="text-gray-600 mb-1">
                                Número de cascos
                            </label>
                            <input
                                type="number"
                                name="numberOfHelmets"
                                id="numberOfHelmets"
                                value={formData.numberOfHelmets}
                                onChange={handleChange}
                                className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                min="0"
                                required={formData.hasHelmets} // 👈 obligatorio solo si está checkeado
                            />
                        </div>
                    </>
                )}

                {formData.booking && (
                    <>
                        <div className="flex flex-col">
                            <label htmlFor="ownerName" className="text-gray-600 mb-1">
                                Número de reserva
                            </label>
                            <input
                                type="text"
                                name="numberOfBooking"
                                id="numberOfBooking"
                                value={formData.numberOfBooking}
                                onChange={handleChange}
                                className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                required={formData.booking}
                            />
                        </div>
                    </>
                )}

                {formData.requiredInvoice && (
                    <>
                        <div className="flex flex-col">
                            <label htmlFor="ownerName" className="text-gray-600 mb-1">
                                Nombre del propietario
                            </label>
                            <input
                                type="text"
                                name="ownerName"
                                id="ownerName"
                                value={formData.ownerName}
                                onChange={handleChange}
                                className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                required={formData.requiredInvoice}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label htmlFor="idNumber" className="text-gray-600 mb-1">
                                Número de cédula
                            </label>
                            <input
                                type="text"
                                name="idNumber"
                                id="idNumber"
                                value={formData.idNumber}
                                onChange={handleChange}
                                className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                required={formData.requiredInvoice}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label htmlFor="email" className="text-gray-600 mb-1">
                                Correo
                            </label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                required={formData.requiredInvoice}
                            />
                        </div>

                        <div className="flex flex-col">
                            <label htmlFor="address" className="text-gray-600 mb-1">
                                Dirección
                            </label>
                            <input
                                type="text"
                                name="address"
                                id="address"
                                value={formData.address}
                                onChange={handleChange}
                                className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                required={formData.requiredInvoice}
                            />
                        </div>
                    </>
                )}

            </div>

            {/* Botones */}
            <div className="flex gap-2 mt-4">
                <GradientButton
                    type="submit"
                    className="flex-1"
                >
                    {parkingData._id ? "Guardar" : "Registrar"}
                </GradientButton>
                <CancelButton onClick={onCancel} />
            </div>
        </form>
        </>
    );
};

export default ParkingRegisterForm;
